import { render, staticRenderFns } from "./headers.vue?vue&type=template&id=7f77c9d2&scoped=true"
import script from "./headers.vue?vue&type=script&lang=js"
export * from "./headers.vue?vue&type=script&lang=js"
import style0 from "./headers.vue?vue&type=style&index=0&id=7f77c9d2&prod&scoped=true&lang=less"
import style1 from "./headers.vue?vue&type=style&index=1&id=7f77c9d2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f77c9d2",
  null
  
)

export default component.exports